/* Échiquier Boutique — encart boutique au milieu des articles du blog (Claude). */
(function () {
  'use strict';
  function run() {
    if (!document.body.classList.contains('template-article')) { return; }
    var body = document.querySelector('[itemprop="articleBody"]');
    if (!body || body.querySelector('.eb-article-cta')) { return; }
    var heads = body.querySelectorAll('h2');
    if (heads.length < 4) { return; }
    var fr = (document.documentElement.lang || 'fr').indexOf('fr') === 0;
    var root = fr ? '' : '/en';
    var box = document.createElement('aside');
    box.className = 'eb-article-cta';
    box.innerHTML = fr
      ? '<p class="eb-article-cta__title">Envie de jouer sur un bel échiquier ?</p><p class="eb-article-cta__text">Nos jeux sont choisis un par un et expédiés sous 24/48 h.</p><ul class="eb-article-cta__links"><li><a href="/collections/jeux-echecs-bois">Jeux d’échecs en bois</a></li><li><a class="eb-alt" href="/collections/meilleures-ventes">Meilleures ventes</a></li><li><a class="eb-alt" href="/collections/jeux-echecs-electroniques">Jeux électroniques</a></li></ul>'
      : '<p class="eb-article-cta__title">Looking for a fine chess set?</p><p class="eb-article-cta__text">Our sets are hand-picked and shipped within 24 to 48 hours.</p><ul class="eb-article-cta__links"><li><a href="/en/collections/jeux-echecs-bois">Wooden chess sets</a></li><li><a class="eb-alt" href="/en/collections/meilleures-ventes">Best sellers</a></li><li><a class="eb-alt" href="/en/collections/jeux-echecs-electroniques">Electronic chess</a></li></ul>';
    var target = heads[2];
    target.parentNode.insertBefore(box, target);
  }
  if (document.readyState !== 'loading') { setTimeout(run, 0); } else { document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); }); }
})();
